/**
 * Copyright (c) 2018-present, Luojun Jin
 *
 * @emails john.king.ca@gmail.com
 */

import React, {Fragment, PureComponent} from 'react';

import Select from 'react-select';
import CreatableSelect from 'react-select/lib/Creatable';
import { FixedSizeList as List } from 'react-window';

const createExpansionOption = (label: string) => ({
  label,
  value: parseInt(label, 10),
});

const defaultExpansionOptions = [
  createExpansionOption('3'),
  createExpansionOption('4'),
  createExpansionOption('5'),
  createExpansionOption('6'),
  createExpansionOption('7'),
  createExpansionOption('8'),
];

const height = 35;
const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  // backgroundColor: '#666666',
  color: '#00875A',
  fontSize: 14,
};

const groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#FF5630',
  display: 'inline-block',
  // fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center',
};

class VerseList extends PureComponent {
  render() {
    const height = 35;
    const { options, children, maxHeight, getValue } = this.props;
    const [value] = getValue();
    const initialOffset = options.indexOf(value) * height;

    return (
      <List
        height={maxHeight}
        itemCount={children.length}
        itemSize={height}
        initialScrollOffset={initialOffset}
      >
        {({ index, style }) => <div style={style}>{children[index]}</div>}
      </List>
    );
  }
}

const formatGroupLabel = data => (
  <div style={groupStyles}>
    <span>{data.label}</span>
    <span style={groupBadgeStyles}>{data.options.length}</span>
  </div>
);

class GroupedVerseSelection extends PureComponent {
  state = {
    isOptionsLoading: false,
    expansionOptions: defaultExpansionOptions,
    selectedExpansionDepthOption: undefined,
  }

  constructor(props) {
    super(props);
  }

  /**
   * set the expansion depth of kepan tree, and display kepan tree based on:
   *  1. selected verse
   *  2. newly selected expansion depth
   */
  handleSelectExpansionDepth = (selectedExpansionDepthOption, actionMeta) => {
    this.setState({ selectedExpansionDepthOption});

    // show kepan base on the saved verse and current expansion depth
    const {selectedVerseOption} = this.props;
    if (selectedVerseOption && selectedVerseOption.value) {
      this.props.createKepanTree(selectedVerseOption.value, selectedExpansionDepthOption.value);
    }
  }

  /**
   * create a customised expansion depth and display the kepan tree based on:
   *  1. selected verse
   *  2. newly creately expansion depth
   */
  handleCreateExpansionDepth = (inputValue: any) => {
    this.setState({ isOptionsLoading: true });

    setTimeout(() => {
      const { expansionOptions } = this.state;
      const newOption = createExpansionOption(inputValue);
      this.setState({
        isOptionsLoading: false,
        expansionOptions: [...expansionOptions, newOption],
        selectedExpansionDepthOption: newOption,
      });
    }, 1000);

    this.props.createKepanTree(this.state.selectedVerseOption.value, inputValue);

  };

  /**
   * show the sub kepan tree for selected verse, the depth of tree depends on
   *   - default depth
   *   - selected depth and
   *   - the depth of kepan tree
   */
  handleVerseSelection = (selectedVerseOption) => {
    let depth = this.state.selectedExpansionDepthOption
      ? this.state.selectedExpansionDepthOption.value
      : null;
    this.props.createKepanTree(selectedVerseOption.value, depth);
  }

  render() {
    const {groupedVerseOptions, selectedVerseOption, selectedExpansionDepthOption} = this.props;
    const { isOptionsLoading, expansionOptions } = this.state;

    return (
      <Fragment>
        <Select css={{fontSize: '12'}}
          autoFocus="true"
          className="basic-single"
          value={selectedVerseOption}
          placeholder="输入...或选择颂词，缺省为全部"
          onChange={this.handleVerseSelection}
          components={{VerseList}}
          options={groupedVerseOptions}
          formatGroupLabel={formatGroupLabel}

        />
        <CreatableSelect css={{fontSize: '12'}}
          isDisabled={isOptionsLoading || !selectedVerseOption}
          isLoading={isOptionsLoading}
          onChange={this.handleSelectExpansionDepth}
          onCreateOption={this.handleCreateExpansionDepth}
          options={expansionOptions}
          value={selectedExpansionDepthOption}
          placeholder="输入...或选择层次，缺省为4"
        />
      </Fragment>
    );
  } // end of render
}
export default GroupedVerseSelection;

